// src/api/Chat/entityChatApi.js
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("Token no encontrado");
  return { Authorization: `Bearer ${token}` };
};

const chatBase = (entityType, entityId) =>
  `${API_URL}/api/chat/${entityType}/${entityId}`;

export const getEntityChatMensajes = async (entityType, entityId) => {
  const res = await axios.get(`${chatBase(entityType, entityId)}/mensajes`, {
    headers: getAuthHeaders(),
  });
  return res.data;
};

export const postEntityChatMensaje = async (entityType, entityId, data) => {
  const res = await axios.post(
    `${chatBase(entityType, entityId)}/mensajes`,
    data,
    { headers: getAuthHeaders() }
  );
  return res.data;
};

export const deleteEntityChatMensaje = async (
  entityType,
  entityId,
  mensajeId
) => {
  const res = await axios.delete(
    `${chatBase(entityType, entityId)}/mensajes/${mensajeId}`,
    { headers: getAuthHeaders() }
  );
  return res.data;
};

export const getEntityChatParticipantes = async (entityType, entityId) => {
  const res = await axios.get(
    `${chatBase(entityType, entityId)}/participantes`,
    { headers: getAuthHeaders() }
  );
  return res.data;
};

export const postEntityChatParticipante = async (entityType, entityId, data) => {
  const res = await axios.post(
    `${chatBase(entityType, entityId)}/participantes`,
    data,
    { headers: getAuthHeaders() }
  );
  return res.data;
};

export const deleteEntityChatParticipante = async (
  entityType,
  entityId,
  userId
) => {
  const res = await axios.delete(
    `${chatBase(entityType, entityId)}/participantes/${userId}`,
    { headers: getAuthHeaders() }
  );
  return res.data;
};

export const marcarEntityChatLeidos = async (entityType, entityId) => {
  const res = await axios.post(
    `${chatBase(entityType, entityId)}/mensajes/leidos`,
    {},
    { headers: getAuthHeaders() }
  );
  return res.data;
};

export const getEntityChatNoLeidos = async (entityType, entityId, userId) => {
  const res = await axios.get(
    `${chatBase(entityType, entityId)}/mensajes/noleidos/${userId}`,
    { headers: getAuthHeaders() }
  );
  return res.data;
};

export const getEntityChatCount = async (entityType, entityId) => {
  const res = await axios.get(
    `${chatBase(entityType, entityId)}/mensajes/count`,
    { headers: getAuthHeaders() }
  );
  return res.data;
};

export const getEntityChatSummary = async (entityType, userId) => {
  const res = await axios.get(
    `${API_URL}/api/chat/${entityType}/summary/${userId}`,
    { headers: getAuthHeaders() }
  );
  return res.data;
};
